// extracted by mini-css-extract-plugin
export default {"background":"Login_background__m4o6m"};